const setList = (state, payload) => {
  state.list = payload;
};

const setItem = (state, payload) => {
  state.item = payload;
};

const setLoaded = (state, payload) => {
  state.loaded = payload;
};

const setTotal = (state, payload) => {
  state.total = payload;
};

const appendList = (state, payload) => {
  state.list = [...state.list, ...payload];
};

const incrementCurrent = state => {
  state.current++;
};

const rewind = state => {
  state.list = [];

  state.current = 0;

  state.total = Number.MAX_SAFE_INTEGER;
};

export default {
  setList,
  setItem,
  appendList,
  setTotal,
  incrementCurrent,
  rewind,
  setLoaded
};
